import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const supportedLngs = ["en", "es", "pt", "de", "zh"];

// Detect the language from the first path segment (/es/…) before anything else,
// so path-based locales drive the initial language. Returns undefined for the
// English root and unknown segments so detection falls through to the rest.
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: "pathLng",
  lookup() {
    if (typeof window === "undefined") return undefined;
    const seg = window.location.pathname.split("/")[1];
    return supportedLngs.includes(seg) && seg !== "en" ? seg : undefined;
  },
});

i18n.use(HttpBackend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs,
    ns: ["landing", "site", "guides"],
    defaultNS: "landing",
    debug: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ["pathLng", "querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "aurora_lang",
      caches: ["localStorage"],
    },
    backend: {
      loadPath: "/locales/{{ns}}/{{lng}}.json",
    },
    react: { useSuspense: true },
  });

export default i18n;
